import { render, staticRenderFns } from "./AuthenticatedDashboard.vue?vue&type=template&id=9dfb9b9c"
import script from "./AuthenticatedDashboard.vue?vue&type=script&lang=js"
export * from "./AuthenticatedDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports